import { useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ReplayIcon from '@mui/icons-material/Replay';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Session from '../shared/Session';
import { DateTimeWidget } from './DateTimeWidget';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';


export default function TaskResultView(props: any) {
    const [accordionExpanded, setAccordionExpanded] = useState(false);
    const [filteredLog, setFilteredLog] = useState("");
    const [log, setLog] = useState("");

    var key = props.taskResult.id;

    function loadLog() {
        if(log === "") {
            Session.api("GET", "/task_results/" + key, {}, (result: any) => {
                setLog(result.log);
            });
        }
    }

    return (<div id={key}>
        <Typography variant="h6" align="left" gutterBottom component="h6">
            {props.taskResult.successful ? <CheckCircleIcon style={{ margin: "3px !important" }} sx={{ color: "green" }} /> : <CancelIcon style={{ margin: "3px !important" }} sx={{ color: "red" }} />}
            <Tooltip title="Rerun Task Once Now">
                <IconButton size="small" color="inherit" style={{ margin: "3px !important" }} onClick={() => {
                    Session.rerunTask(props.taskResult);
                }}>
                    <ReplayIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Delete Forever">
                <IconButton size="small" style={{ margin: "3px !important" }} onClick={() => {
                    (document.getElementById(key) as HTMLElement).style.display = "none";
                    Session.api("DELETE", "/task_results/" + props.taskResult.id, {}, null, null, false);
                }}>
                    <DeleteForeverIcon color="error" />
                </IconButton>
            </Tooltip>
            {props.taskResult.name} {props.taskResult.function}
        </Typography>
        <DateTimeWidget dt={props.taskResult.execution_started} addTimeAgo={true} />
        <Typography variant="body1" align="left" gutterBottom>{props.taskResult.execution_seconds} execution seconds</Typography>
        <Typography variant="body1" align="left" gutterBottom>Parameters: {JSON.stringify(props.taskResult.parameters, null, 4)}</Typography>
        <Accordion
            // https://mui.com/material-ui/react-accordion/#transition
            expanded={accordionExpanded}
            style={{ width: accordionExpanded ? "100%" : "10em" }}
        >

            <AccordionSummary
                style={{ minHeight: "40px", height: "40px" }}
                id={"panel1a-header"}
                aria-controls="panel1a-content"
                expandIcon={<ExpandMoreIcon />}
                onClick={() => {
                    loadLog();
                    setAccordionExpanded(!accordionExpanded);
                }}
            >
                <Typography>View Log</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {log === "" ? <CircularProgress /> : <>
                    <pre style={{ display: "block", overflowY: "auto", maxHeight: "66vh", whiteSpace: "pre-wrap", fontSize: "10px" }}><code>
                        {filteredLog === "" ? log : filteredLog}
                    </code></pre>
                    <Button component="label" variant="contained" startIcon={<CloseIcon />}
                        onClick={() => {
                            setAccordionExpanded(!accordionExpanded);
                        }}>
                        Close Log
                    </Button>&nbsp;
                    <Button component="label" variant="contained"
                        onClick={() => {
                            setFilteredLog(log.split("\n").filter(function (line: string) {
                                return line.includes("NOTE: ") || line.includes("WARNING: ") || line.includes("ERROR: ");
                            }).join("\n"));
                        }}>
                        Filter Notes
                    </Button>&nbsp;
                    <Button component="label" variant="contained"
                        onClick={() => {
                            setFilteredLog("");
                        }}>
                        Clear Filter
                    </Button>
                </>}
            </AccordionDetails>
        </Accordion>
        <br />
    </div>)
}
